import { useQuery } from '@tanstack/react-query'
import { QUERY_KEY } from '@/utils'
import { getEnterpriseInfo } from '@/services'

export const useEnterpriseInfo = () => {
  const { data: enterpriseInfo, refetch: refetchEnterpriseInfo, isFetched: isEnterpriseInfoFetched } = useQuery({
    queryKey: [QUERY_KEY.EnterpriseInfo],
    queryFn: getEnterpriseInfo,
    staleTime: Infinity,
  })

  return {
    enterpriseInfo: enterpriseInfo,
    isEnterpriseInfoFetched,
    getEnterpriseInfo: () => {
      refetchEnterpriseInfo()
    },
  }
}
